import clsx from "clsx";
import React from "react";

type FloatingActionBarProps = {
    totalSelected: number;
    title: string;
    open: boolean;
    onClose: () => void;
    children: React.ReactNode;
};
export default function FloatingActionBar(props: FloatingActionBarProps) {
    const { totalSelected, open, title, onClose, children } = props;
    return (
        <div
            className={clsx(
                open ? "" : "hidden",
                "fixed bottom-[20px] left-1/2 -translate-x-1/2 flex items-center justify-center  bg-white border border-slate-200 rounded-lg p-2.5 gap-2 w-fit shadow-[0_4px_4px_0_rgba(0,0,0,0.05),0_12px_16px_-4px_rgba(16,24,40,0.08),0_4px_6px_-2px_rgba(16,24,40,0.03)]"
            )}
        >
            <p className="text-sm text-g-75 bg-y-10 px-2 py-0.5 rounded  font-rocGroteskMedium">
                {totalSelected}
            </p>
            <p className="text-sm text-gm-50 font-rocGroteskMedium whitespace-nowrap">{title}</p>

            <div>{children}</div>

            <i
                className="ri-close-fill text-[#64748B] text-lg font-bold ml-1 cursor-pointer"
                onClick={onClose}
            ></i>
        </div>
    );
}
